import type { DocumentEntryPayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';
import DocumentFieldView from '@UI/Store/Documents/Views/DocumentFieldView';
import DocumentGroupView from '@UI/Store/Documents/Views/DocumentGroupView';
import DocumentListEntryView from '@UI/Store/Documents/Views/DocumentListEntryView';
import DocumentListItemView from '@UI/Store/Documents/Views/DocumentListItemView';

export type DocumentEntryView = DocumentFieldView | DocumentGroupView | DocumentListEntryView;

/**
 * Recursively resolves the field/group/list union straight off the wire, entry by entry. `Group` and
 * `List` node classes stay pure data holders — their own constructor takes already-built children —
 * so the recursion lives here alone, and no two node classes ever need to import each other.
 */
const buildDocumentEntryView = (payload: DocumentEntryPayload): DocumentEntryView => {
	if (payload.type === 'field') {
		return new DocumentFieldView(payload);
	}

	if (payload.type === 'group') {
		return new DocumentGroupView(payload, payload.entries.map(buildDocumentEntryView));
	}

	return new DocumentListEntryView(
		payload,
		payload.items.map(
			(item, index) => new DocumentListItemView(item.entries.map(buildDocumentEntryView), index + 1),
		),
	);
};

export default buildDocumentEntryView;
